/* eslint-disable react/no-array-index-key */
import { HeadingDesc } from '../../../Components/Headings';
import { IconCard } from '../../../Components/Card';
import { SimpleSlider } from '../../../Components/sliders';
import icon1 from '../../../assets/images/svg/doctor-icon1.svg';
import icon2 from '../../../assets/images/svg/doctor-icon2.svg';
import icon3 from '../../../assets/images/svg/doctor-icon3.svg';
import icon4 from '../../../assets/images/svg/doctor-icon4.svg';
import './finDocByDisease.css';

const findDocByDiesease = [
  { icon: icon1, title: 'Dermatologist' },
  { icon: icon2, title: 'Gastroenterologist' },
  { icon: icon3, title: 'Urologist' },
  { icon: icon4, title: 'Child Specialist' },
  { icon: icon1, title: 'Dermatologist' },
  { icon: icon2, title: 'Gastroenterologist' },
  { icon: icon3, title: 'Urologist' },
  { icon: icon4, title: 'Child Specialist' }
];

function FinDocByDisease() {
  const sliderData = findDocByDiesease.map((disease, index) => {
    const { icon, title } = disease;
    return <IconCard img={icon} heading={title} key={index + 1} />;
  });
  return (
    <div className="finDocByDisease">
      <SimpleSlider
        className="profileSlider"
        sliderTitle="Are you looking for a doctor?"
        sliderDesc={
          <HeadingDesc text="1 Million+ Patients Found Doctors For Them Through Meri Sehat!" />
        }
      >
        {sliderData}
      </SimpleSlider>
    </div>
  );
}

export default FinDocByDisease;
